import { Instance, Instances, useGLTF, useTexture } from '@react-three/drei';
import { useEffect, useMemo, useRef, useState } from 'react';
import * as THREE from 'three';

// Preload the smallChair model
useGLTF.preload('/env/smallChair.glb');

export function SmallChair({ jsonFile, texturePath }) {
    const { nodes } = useGLTF('/env/smallChair.glb', true, (error) => {
        console.error('Failed to load model', error);
    });

    // Preload the texture
    useTexture.preload(texturePath);
    
    const smallChairTexture = useTexture(texturePath);
    smallChairTexture.colorSpace = THREE.SRGBColorSpace;
    smallChairTexture.flipY = false;
    smallChairTexture.channel = 1;

    const material = useMemo(
        () =>
            new THREE.MeshBasicMaterial({
                toneMapped: false,
                side: THREE.DoubleSide,
                transparent: false,
                map: smallChairTexture
            }),
        [texturePath]
    );

    const [data, setData] = useState([]);

    useEffect(() => {
        fetch(jsonFile)
            .then(response => response.json())
            .then(jsonData => {
                const parsedData = Object.values(jsonData).map((entry) => ({
                    position: mapAxes(entry.position || [0, 0, 0]),
                    scale: mapScale(entry.scale || [0, 0, 0]),
                    rotation: mapRotation(entry.rotation || [0, 0, 0]),
                }));
                setData(parsedData);
            })
            .catch(error => console.error('Error loading JSON:', error));
    }, [jsonFile]);

    return (
        data.length > 0 && (
            <Instances
                range={data.length}
                geometry={nodes.chairSmall.geometry}
                material={material}
            >
                {data.map((props, i) => (
                    <SmallChairs key={i} {...props} />
                ))}
            </Instances>
        )
    );
}

function SmallChairs({ position, scale, rotation }) {
    const ref = useRef();
    return (
        <group position={position} scale={scale} rotation={rotation}>
            <Instance ref={ref} />
        </group>
    );
}

// Function to remap Blender axes to Three.js axes
function mapAxes([x, y, z]) {
    return [x, z, -y];
}

function mapRotation([rx, ry, rz]) {
    return [rx, rz, -ry];
}

function mapScale([rx, ry, rz]) {
    return [rx, ry, rz];
}